import AbstractComponent from "./abstract-component";

const createTemplate = () => {
  return (
    `<section class="modal">
      <div class="modal__overlay"></div>
      <div class="modal__wrap authorization__modalWrap">
        <button class="modal__closeButton" type="button" title="Закрыть">
          <svg aria-hidden="true" width="16" height="16">
            <use class="" href="sienge/img/sprite.svg#close"></use>
          </svg>
        </button>

        <h2 class="modal__title">Сообщить об ошибке</h2>

        <p class="modal__textarea">
          <textarea rows="8" placeholder="Введите текст ошибки..." spellcheck></textarea>
        </p>

        <div class="modal__buttonWrap" data-mode="button">
          <button class="modal__button button-primary js--send" type="button">Отправить</button>
          <div class="modal__progress">
            <img src="/sienge/img/load_bar.gif" alt="">
          </div>
        </div>

      </div>
    </section>`
  );
};

export default class ErrorModalComponent extends AbstractComponent {
  constructor(className = ``) {
    super();

    this._className = className;

    this._focusTextarea();
  }

  getTemplate() {
    return createTemplate(this._className);
  }

  setShowClass() {
    this.getElement().classList.add(`modal--show`);
  }

  setCloseButtonClickHandler(handler) {
    this.getElement().querySelector(`.modal__closeButton`)
    .addEventListener(`click`, handler);
  }

  setOverlayClickHandler(handler) {
    this.getElement().querySelector(`.modal__overlay`)
    .addEventListener(`click`, handler);
  }

  setSendButtonClickHandler(handler) {
    this.getElement().querySelector(`.js--send`)
    .addEventListener(`click`, () => {
      this.getElement().querySelector(`.modal__buttonWrap`).dataset.mode = `progress`;

      const message = this.getElement().querySelector(`textarea`).value;
      handler(message, () => {
        this.getElement().querySelector(`.modal__buttonWrap`).dataset.mode = `button`;
      });
    });
  }

  _focusTextarea() {
    const textarea = this.getElement().querySelector(`textarea`);
    if (textarea) {
      textarea.focus();
    }
  }
}
